<template>
  <div class="last-completed" data-test="last-completed">
    {{ text }}
    {{ timeDiffFromNow(lastCompleted, $t) }}
  </div>
</template>
<script setup lang="ts">
import { defineProps } from "vue";
import { timeDiffFromNow } from "@/helpers";

interface Props {
  lastCompleted: string;
  text: string;
}

defineProps<Props>();
</script>

<style scoped>
.last-completed {
  color: var(--dark-grey);
  font-size: 16px;
  font-style: italic;
  line-height: 24px;
  letter-spacing: 0.15px;
}
</style>
